<div class="selected-panel file-panel">
  <mat-card-header>
    <mat-card-title>
      {{ title }}
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <!-- Selected files header -->
    <div class="file-list-header" *ngIf="selectedFiles.length > 0">
      <div class="header-column header-checkbox-icon"></div>
      <div class="header-column header-icon"></div>
      <div class="header-column header-name">Name</div>
      <div class="header-column header-size">Size</div>
      <div class="header-column header-date">Last Modified</div>
    </div>

    <!-- Selected files list -->
    <div class="selected-files-list" *ngIf="selectedFiles.length > 0; else noFilesSelected">
      <div *ngFor="let file of selectedFiles" class="selected-file-item">
        <mat-checkbox 
          [checked]="file.selected" 
          (change)="onFileCheckboxChange(file, $event.checked)">
        </mat-checkbox>
        
        <mat-icon class="file-icon">
          {{ file.type === 'image' ? 'image' : 'description' }}
        </mat-icon>
        
        <div class="file-info-column">
          <span class="file-name" [matTooltip]="file.name">
            {{ file.name }}
          </span>
          <mat-icon *ngIf="file.isDuplicate" 
                  class="warning-icon" 
                  matTooltip="This file may already exist at the destination">
            warning
          </mat-icon>
        </div>
        
        <span class="file-size">{{ file.size }}</span>
        <span class="file-date">{{ file.date }}</span>
      </div>
    </div>

    <!-- Empty state message -->
    <ng-template #noFilesSelected>
      <div class="no-files-selected">
        <mat-icon>info</mat-icon>
        <p>No files selected for transfer</p>
      </div>
    </ng-template>
  </mat-card-content>
  
  <!-- Share button -->
  <div class="action-buttons">
    <button class="share-button" 
            [disabled]="selectedFiles.length === 0"
            (click)="onShareSelected()">
      <span>Share selected</span>
      <mat-icon>arrow_forward</mat-icon>
    </button>
  </div>
</div> 